export const canDownload = (description, currentDownloads) => {
  if (currentDownloads.length == 0) {
    return true;
  }

  return !currentDownloads.some(
    (file) => file.identifier == description
  );
};



// WEBPACK FOOTER //
// ./src/components/common/CanDownload.js